export default __webpack_public_path__ + "static/media/position-list-v2.81b02761.svg";